module.exports = __webpack_public_path__ + "media/application/images/svgs/icon-right-carrot-25dd55b80d84becef0a9e176f904474d.svg";